/**
 * @flow
 * @relayHash 6cb815cab48f3dfb9ee052efcd9c6fb2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type NavDrawerQueryVariables = {|
  id?: ?string
|};
export type NavDrawerQueryResponse = {|
  +authorizedSuborgs: $ReadOnlyArray<{|
    +id: string,
    +name: string,
    +region: ?string,
    +propertyLogoUrl: ?string,
    +propertyManagerLogoUrl: ?string,
    +org: {|
      +id: string,
      +name: string,
    |},
    +linkColor: ?string,
    +fontFamily: ?string,
    +textColor: ?string,
    +buttonBorderColor: ?string,
    +buttonFontColor: ?string,
    +buttonBackgroundColor: ?string,
  |}>
|};
export type NavDrawerQuery = {|
  variables: NavDrawerQueryVariables,
  response: NavDrawerQueryResponse,
|};
*/


/*
query NavDrawerQuery(
  $id: String
) {
  authorizedSuborgs(orgId: "any", first: 1, propertyId: $id) {
    id
    name
    region
    propertyLogoUrl
    propertyManagerLogoUrl
    org {
      id
      name
    }
    linkColor
    fontFamily
    textColor
    buttonBorderColor
    buttonFontColor
    buttonBackgroundColor
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "authorizedSuborgs",
    "storageKey": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      },
      {
        "kind": "Literal",
        "name": "orgId",
        "value": "any"
      },
      {
        "kind": "Variable",
        "name": "propertyId",
        "variableName": "id"
      }
    ],
    "concreteType": "Suborg",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "region",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "propertyLogoUrl",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "propertyManagerLogoUrl",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "org",
        "storageKey": null,
        "args": null,
        "concreteType": "Org",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "linkColor",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "fontFamily",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "textColor",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "buttonBorderColor",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "buttonFontColor",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "buttonBackgroundColor",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "NavDrawerQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "NavDrawerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "NavDrawerQuery",
    "id": null,
    "text": "query NavDrawerQuery(\n  $id: String\n) {\n  authorizedSuborgs(orgId: \"any\", first: 1, propertyId: $id) {\n    id\n    name\n    region\n    propertyLogoUrl\n    propertyManagerLogoUrl\n    org {\n      id\n      name\n    }\n    linkColor\n    fontFamily\n    textColor\n    buttonBorderColor\n    buttonFontColor\n    buttonBackgroundColor\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f54e945f8ddcc4e7b25b9368aef4c894';
module.exports = node;
